import { redirect } from "@tanstack/react-router";

import type { UserRole } from "@kansai-ai-hub/types";

import type { AuthContext } from "@/features/auth/auth-types";

/**
 * ロール認可ヘルパー。`createFileRoute(...)({ beforeLoad: requireRole("ADMIN") })` で使う。
 *
 * - 未認証は `_authenticated.tsx` の beforeLoad で `/`（ログインモーダル）に redirect 済みなので、
 *   ここに来た時点で `auth.user` は非 null と仮定して良い (defensive に null check はする)。
 * - ロール不一致は `/` (landing) へ redirect。landing 側の beforeLoad で role 別の dashboard
 *   へ再 redirect されるので、ENTERPRISE ユーザが `/admin/cases` を叩いても最終的に
 *   `/enterprise` に着地する。
 *
 * 9 つの layout で同じガードを書いていたコードをこのヘルパーに集約。leaf 側でも 18 ファイルで
 * 同パターンが繰り返されていたが、layout でガードできれば leaf 側のガードは不要 (beforeLoad は
 * root→leaf 順で実行され、layout で throw すれば leaf には到達しない)。
 */
export function requireRole(role: UserRole) {
  return ({ context }: { context: { auth: AuthContext } }) => {
    if (context.auth.user?.role !== role) {
      throw redirect({ to: "/" });
    }
  };
}
